var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.561 4.1875H14.9355V16.2313C14.9355 16.3816 14.8137 16.5036 14.6632 16.5036H5.75769V17.1291C5.75769 17.2796 5.87955 17.4015 6.03003 17.4015H15.5612C15.7117 17.4015 15.8335 17.2796 15.8335 17.1291V4.45966C15.8335 4.4239 15.8265 4.38849 15.8128 4.35545C15.799 4.32242 15.779 4.29241 15.7537 4.26714C15.7284 4.24187 15.6983 4.22183 15.6653 4.20816C15.6322 4.1945 15.5968 4.18748 15.561 4.1875Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0379 15.3364V2.66687C14.0379 2.51639 13.916 2.39453 13.7656 2.39453H13.1401V14.4385C13.1401 14.589 13.0182 14.7109 12.8677 14.7109H3.96204V15.3364C3.96204 15.4868 4.0839 15.6087 4.23438 15.6087H13.7656C13.916 15.6087 14.0379 15.4868 14.0379 15.3364Z",
    fill: "#3D3D3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2423 13.5395V0.869996C12.2423 0.719516 12.1204 0.597656 11.97 0.597656H2.43897C2.28849 0.597656 2.16663 0.719516 2.16663 0.869996V13.5395C2.16663 13.69 2.28849 13.8118 2.43897 13.8118H11.97C12.1204 13.8118 12.2423 13.69 12.2423 13.5395Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.60984ef8b797c0c79d5d8fce27484436.svg";
export { ForwardRef as ReactComponent };